import React from "react";
import { styled } from "@mui/material/styles";
import { Card } from "@mui/material";

const StyledCard = styled(Card)(({ theme }) => ({
  width: "100%",
  borderRadius: theme.shape.customBorderRadius[4],
  boxShadow: "1px 1px 4px 0 rgba(0, 0, 0, 0.2)",
  backgroundColor: theme.palette.primary.white,
  padding: "10px 15px",
}));

const MainCard = ({ children, ...props }) => {
  return (
    <StyledCard {...props}>
      {children}
    </StyledCard>
  );
};

export default MainCard;
